import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const UploadIcon = ({
  size = 24,
  sx,
  color,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.68 11.7097V20.0297H4.32001V11.7097"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.16 3.97013L16.32 7.81013M12.16 3.97013L8.32001 7.81013M12.16 3.97013L12.16 16.1301"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
